"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CURRENT_AVAILABLE_NOTIFICATIONS = exports.NotificationComponentByType = exports.getBGColorByRarity = exports.formatMana = exports.MAXIMUM_FRACTION_DIGITS = void 0;
var schemas_1 = require("@dcl/schemas");
var types_1 = require("./types");
var NotificationTypes_1 = require("./NotificationTypes");
exports.MAXIMUM_FRACTION_DIGITS = 2;
function formatMana(mana, maximumFractionDigits) {
    if (maximumFractionDigits === void 0) { maximumFractionDigits = exports.MAXIMUM_FRACTION_DIGITS; }
    return (Number(mana) / 1e18).toFixed(maximumFractionDigits).toLocaleString();
}
exports.formatMana = formatMana;
function getBGColorByRarity(rarity) {
    return schemas_1.Rarity.getGradient(rarity).join();
}
exports.getBGColorByRarity = getBGColorByRarity;
exports.NotificationComponentByType = (_a = {},
    _a[types_1.DecentralandNotificationType.ROYALTIES_EARNED] = NotificationTypes_1.RoyaltiesEarnedNotification,
    _a[types_1.DecentralandNotificationType.ITEM_SOLD] = NotificationTypes_1.ItemSoldNotification,
    _a[types_1.DecentralandNotificationType.BID_ACCEPTED] = NotificationTypes_1.BidAcceptedNotification,
    _a[types_1.DecentralandNotificationType.BID_RECEIVED] = NotificationTypes_1.BidReceivedNotification,
    _a[types_1.DecentralandNotificationType.GOVERNANCE_ANNOUNCEMENT] = NotificationTypes_1.GovernanceAnnouncementNotification,
    _a[types_1.DecentralandNotificationType.GOVERNANCE_COAUTHOR_REQUESTED] = NotificationTypes_1.GovernanceCoauthorRequestedNotification,
    _a[types_1.DecentralandNotificationType.GOVERNANCE_AUTHORED_PROPOSAL_FINISHED] = NotificationTypes_1.GovernanceAuthoredProposalFinishedNotification,
    _a[types_1.DecentralandNotificationType.GOVERNANCE_NEW_COMMENT_ON_PROPOSAL] = NotificationTypes_1.GovernanceNewCommentOnProposalNotification,
    _a[types_1.DecentralandNotificationType.GOVERNANCE_PROPOSAL_ENACTED] = NotificationTypes_1.GovernanceProposalEnactedNotification,
    _a[types_1.DecentralandNotificationType.GOVERNANCE_VOTING_ENDED_VOTER] = NotificationTypes_1.GovernanceVotingEndedVoterNotification,
    _a[types_1.DecentralandNotificationType.WORLDS_MISSING_RESOURCES] = NotificationTypes_1.WorldsMissingResourcesNotification,
    _a[types_1.DecentralandNotificationType.WORLDS_ACCESS_RESTORED] = NotificationTypes_1.WorldsAccessRestoredNotification,
    _a[types_1.DecentralandNotificationType.WORLDS_ACCESS_RESTRICTED] = NotificationTypes_1.WorldsAccessRestrictedNotification,
    _a[types_1.DecentralandNotificationType.LAND_RENTED] = NotificationTypes_1.LandRentedNotification,
    _a[types_1.DecentralandNotificationType.LAND_RENTAL_ENDED] = NotificationTypes_1.LandRentalEndedNotification,
    _a[types_1.DecentralandNotificationType.REWARD_ASSIGNED] = NotificationTypes_1.RewardAssignedNotification,
    _a[types_1.DecentralandNotificationType.EVENTS_STARTS_SOON] = NotificationTypes_1.EventsStartsSoonNotification,
    _a[types_1.DecentralandNotificationType.EVENTS_STARTED] = NotificationTypes_1.EventsStartedNotification,
    _a);
exports.CURRENT_AVAILABLE_NOTIFICATIONS = Object.values(types_1.DecentralandNotificationType);
